/**
 * Terms and Conditions of Use - RouteX AI
 * Displayed on registration (signup) page; user must agree before creating an account.
 */

export const TERMS_LAST_UPDATED = '25 March 2026';

export const TERMS_AND_CONDITIONS = `Terms and Conditions of Use

Last updated: 25 March 2026

These Terms and Conditions ("Terms") govern your access to and use of the RouteX AI mobile application, website, and related services (collectively, the "Service" or "App"), operated by RouteX AI Ltd, a company registered in the United Kingdom ("RouteX AI", "we", "us", "our").

By creating an account or using the App, you confirm that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must not use the App.

1. Eligibility

You must be:

• At least 16 years old, or the minimum legal age required in your country, and
• Legally capable of entering into a binding agreement.

By using the App, you confirm that you meet these requirements.

2. The Service

RouteX AI is a consumer-facing, AI-powered travel planning and discovery application that enables users to:

• Provide travel interests, preferences, locations, and start/end points
• Receive personalised routes, recommendations, and travel insights
• Interact with AI-driven features powered by automated decision-making systems

The App integrates third-party services and APIs, including artificial intelligence, mapping, routing, analytics, and advertising technologies (such as OpenAI, Google, and similar providers).

The Service may include contextual and/or personalised advertising.

We may update, modify, suspend, or discontinue any part of the Service at any time, temporarily or permanently, with or without notice.

3. Account & Acceptable Use

When creating and using an account, you agree to:

• Provide accurate, complete, and up-to-date information
• Maintain the security of your account credentials
• Use the App only for lawful purposes
• Not misuse, reverse engineer, decompile, scrape, crawl, interfere with, or attempt to disrupt the App, its systems, or networks

You are responsible for all activity conducted through your account.

We may suspend or terminate your access if you violate these Terms.

4. User Content & Data

4.1 Ownership

You retain ownership of any content, data, or information you submit, upload, generate, or make available through the App ("User Content").

4.2 License to RouteX AI (IMPORTANT)

By using the App, you grant RouteX AI Ltd a worldwide, non-exclusive, royalty-free, transferable, sublicensable licence to:

use, host, store, reproduce, modify, analyse, create derivative works from, aggregate, anonymise, distribute, and display your User Content and related usage data for the purposes of:

• Operating and providing the Service
• Improving, developing, and securing the App
• Training, testing, and optimising artificial intelligence and machine learning models
• Analytics, research, and product development
• Advertising, monetisation, and commercial activities

This licence continues even if you stop using the App, to the extent that the data has been anonymised or aggregated.

5. AI Training & Product Improvement

You acknowledge and agree that:

• User Content and usage data may be used to train, improve, and optimise AI models
• AI systems are designed not to store personal data in a directly identifiable form
• Outputs generated by the App are automated and may be inaccurate, incomplete, or outdated
• Outputs should not be relied upon as professional, legal, medical, or safety advice
• All travel decisions remain your responsibility.

6. Anonymised & Aggregated Data

We may:

• Aggregate and anonymise data so that it can no longer reasonably identify you
• Use, share, licence, or sell such anonymised or aggregated data for analytics, research, commercial, advertising, and business purposes, including with third parties and industry partners
• Once anonymised, this data is not personal data under applicable data protection laws.

7. Privacy & Data Protection

Our collection and use of personal data are described in our Privacy Policy, which forms part of these Terms.

We process personal data based on:

• Contractual necessity
• Legitimate interests
• Consent, where required by law

You may exercise your data protection rights as described in the Privacy Policy.

8. Advertising & Personalisation

We may:

• Personalise content, recommendations, and user experiences
• Display advertising within the App
• Use data for analytics and marketing, subject to applicable law and your preferences

You may manage certain settings and preferences through the App where available.

9. App Stores & Third-Party Services

These Terms are between you and RouteX AI Ltd, not Apple, Google, or any app store provider.

Third-party services, content, or integrations may be subject to their own terms and policies. We are not responsible for third-party services.

10. Intellectual Property

All rights in and to the App, including software, algorithms, designs, trademarks, branding, and content, are owned by or licensed to RouteX AI Ltd.

You are granted a limited, personal, non-transferable, revocable licence to use the App for personal, non-commercial purposes only.

11. Disclaimer

The App is provided "as is" and "as available."

We make no guarantees that:

• The Service will be uninterrupted, secure, or error-free
• Outputs will be accurate, reliable, or suitable for your needs

Use of the App is at your own risk.

12. Limitation of Liability

To the maximum extent permitted by law:

• We are not liable for indirect, incidental, or consequential damages
• Our total liability is limited to the amount you paid to us (if any) in the 12 months preceding the claim
• Nothing in these Terms limits liability where it cannot legally be excluded.

13. Termination

You may stop using the App at any time.

We may suspend or terminate your access if:

• You breach these Terms
• Required by law or regulation
• The Service is discontinued

14. Changes to These Terms

We may update these Terms from time to time.

Continued use of the App after changes means you accept the updated Terms.

15. Governing Law & Jurisdiction

These Terms are governed by the laws of England and Wales.

The courts of England and Wales shall have exclusive jurisdiction, unless otherwise required by law.

16. Contact

For questions or concerns, contact us at:

RouteX AI Ltd
Email: support@routexai.co

Registered Address: [Company Address]`;
